import { Instagram, ArrowUpRight, MessageCircle } from "lucide-react";
import { toast } from "sonner";
import { VILLA } from "../data";
import { useLang } from "../i18n";

const SITE_URL = "https://villatuttopassa.fr";

export const Footer = () => {
  const { t } = useLang();
  const year = new Date().getFullYear();

  const shareWhatsApp = () => {
    window.open(`https://wa.me/?text=${encodeURIComponent(`${t.footer.shareText} ${SITE_URL}`)}`, "_blank", "noopener");
  };

  const shareInstagram = async () => {
    try {
      await navigator.clipboard.writeText(SITE_URL);
      toast.success(t.footer.shareCopied);
    } catch (e) {
      toast.success(t.footer.shareCopied);
    }
    window.open(VILLA.instagram, "_blank", "noopener");
  };

  return (
    <footer className="bg-ink text-sand-bg pt-20 md:pt-28 pb-10 overflow-hidden" data-testid="site-footer">
      <div className="px-6 md:px-12 max-w-[1600px] mx-auto">
        <div className="grid md:grid-cols-3 gap-10 pb-16 border-b border-white/15">
          <div className="md:col-span-1">
            <p className="font-serif text-2xl font-light mb-4">Villa Tutto Passa</p>
            <p className="text-sand-bg/60 font-light text-sm leading-relaxed max-w-xs">{VILLA.location}</p>
          </div>
          <div>
            <p className="text-[11px] tracking-[0.3em] uppercase text-sand-bg/50 mb-5">{t.footer.contact}</p>
            <a href={`mailto:${VILLA.email}`} className="block text-sand-bg/85 hover:text-terracotta transition-colors mb-2 text-sm" data-testid="footer-email">{VILLA.email}</a>
            <a href={`tel:${VILLA.phone.replace(/\s/g, "")}`} className="block text-sand-bg/85 hover:text-terracotta transition-colors text-sm" data-testid="footer-phone">{VILLA.phone}</a>
          </div>
          <div>
            <p className="text-[11px] tracking-[0.3em] uppercase text-sand-bg/50 mb-5">{t.footer.follow}</p>
            <a
              href={VILLA.instagram}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="instagram-link"
              className="group inline-flex items-center gap-3 text-sand-bg/85 hover:text-terracotta transition-colors"
            >
              <Instagram className="w-5 h-5" strokeWidth={1.4} />
              <span className="text-sm">{VILLA.instagramHandle}</span>
              <ArrowUpRight className="w-4 h-4 opacity-0 -translate-x-2 group-hover:opacity-100 group-hover:translate-x-0 transition-all duration-300" />
            </a>
            <p className="text-[11px] tracking-[0.3em] uppercase text-sand-bg/50 mt-8 mb-5">{t.footer.share}</p>
            <div className="flex items-center gap-3">
              <button
                onClick={shareWhatsApp}
                data-testid="share-whatsapp-btn"
                aria-label="Partager sur WhatsApp"
                className="inline-flex items-center gap-2 border border-white/25 px-4 py-2 text-sm text-sand-bg/85 hover:border-terracotta hover:text-terracotta transition-colors duration-300"
              >
                <MessageCircle className="w-4 h-4" strokeWidth={1.4} />
                WhatsApp
              </button>
              <button
                onClick={shareInstagram}
                data-testid="share-instagram-btn"
                aria-label="Partager sur Instagram"
                className="inline-flex items-center gap-2 border border-white/25 px-4 py-2 text-sm text-sand-bg/85 hover:border-terracotta hover:text-terracotta transition-colors duration-300"
              >
                <Instagram className="w-4 h-4" strokeWidth={1.4} />
                Instagram
              </button>
            </div>
          </div>
        </div>

        <div className="py-10 md:py-14">
          <h2 className="font-serif font-light leading-none tracking-tight text-[19vw] md:text-[13vw] text-sand-bg/95 whitespace-nowrap">
            Tutto Passa
          </h2>
        </div>

        <div className="flex flex-col md:flex-row justify-between items-start md:items-center gap-4 text-xs text-sand-bg/45">
          <span>© {year} Villa Tutto Passa — Créé par l'agence THE HILL PROJECT</span>
          <span className="font-light flex items-center gap-4">
            {t.footer.showcase}
            <a href="/admin" data-testid="owner-space-link" className="link-underline hover:text-sand-bg/80">{t.footer.owner}</a>
          </span>
        </div>
      </div>
    </footer>
  );
};
